import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="nonzero" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M15.292 1.875l4.312 4.313L6.188 19.604l-4.313-.479v-3.833zM12.896 4.75l3.354 3.354" /></g></svg>);